DialogController = App.loadClass 'core::Angular/DialogController'

class exports.EditCompaniesController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @service, associations) ->
        super(@scope, @transitions, @modalInstance)

        if associations.data.status.type is 'success'
            @scope.companies = associations.data.data.companies
            @scope.user_companies = associations.data.data.user_companies

        for company in @scope.companies
            if @scope.user.id is company.corporate_users_id
                @scope.is_corporate_account_msg = "
                    This user is the corporate account for #{company.name}.
                    You are not permitted to edit this users company associations
                "
                break


    save: () =>
        @service.updateUserCompanies(@scope.user.id, @scope.user_companies)
            .then () =>
                @modalInstance.close()

